import React from "react"
import { LanguageProvider } from "./src/contexts/LanguageContext"

/**
 * Marks the document as JS-enabled so scroll-reveal styles only apply
 * when the IntersectionObserver that removes them can actually run.
 * @type {import('gatsby').GatsbyBrowser['onClientEntry']}
 */
export const onClientEntry = () => {
  document.documentElement.classList.add("js")
}

/**
 * @type {import('gatsby').GatsbyBrowser['wrapRootElement']}
 */
export const wrapRootElement = ({ element }) => {
  return <LanguageProvider>{element}</LanguageProvider>
}

/**
 * Every client-side navigation lands at the top of the new page (or on the
 * `#anchor` it targets). Scrolling is done instantly here because the global
 * `scroll-behavior: smooth` would otherwise animate from the previous page's
 * position and could be cut short mid-way.
 * @type {import('gatsby').GatsbyBrowser['shouldUpdateScroll']}
 */
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  const html = document.documentElement
  const previous = html.style.scrollBehavior
  html.style.scrollBehavior = "auto"

  const jump = () => {
    const target =
      location.hash && document.getElementById(location.hash.slice(1))
    if (target) target.scrollIntoView({ block: "start", behavior: "instant" })
    else window.scrollTo({ top: 0, left: 0, behavior: "instant" })
  }

  // Twice: now, and again on the next frame so an in-flight smooth scroll
  // (e.g. the user clicked a link mid-animation) cannot win over it.
  jump()
  requestAnimationFrame(() => {
    jump()
    html.style.scrollBehavior = previous
  })
  return false
}
